module.exports = __webpack_public_path__ + "static/media/june2024-2.4b7a00d3.webp";